export default {
  name: "Recruitment Information",
  prefix: "E.e",
  sections: [
    {
      fields: [
        {
          code: "E.e.1",
          machine_name: "ee1_how_to_apply",
          widget: "text_area",
          rows: 8,
          inputLimit: 880,
          validate: ["required"],
          label:
            "Explain how prospective U.S. applicants may be considered for employment under this job opportunity, including verifiable methods of contacting the employer, and the days and hours applicants can apply for the job.",
          tooltip:
            "Enter verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity. These methods must be identified and entries ARE REQUIRED for submission of this application. Include the days and hours which applicants may apply for the job opportunity listed in this application. Important Note: Enter at least two (2) verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity must be identified and entries ARE REQUIRED for submission of this application. “N/A” may be manually entered for E.d.3 or E.d.4.",
        },
        {
          code: "E.e.2",
          machine_name: "ee2_apply_phone",
          widget: "phone",
          label: "Telephone Number to Apply",
          validate: [
            {
              subsetOfSetRequired: "ee2_apply_phone",
              message:
                "Enter at least two (2) verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  "ee2_apply_phone",
                  "ee3_apply_email",
                  "ee4_apply_website",
                ],
              },
            },
            "phone",
          ],
          maxLength: 60,
          tooltip: `Enter the area code and telephone number by which prospective U.S. workers can contact the employer and apply for the job opportunity. If a phone number is not available, leave this field BLANK and the system will insert “N/A” at submission of the application.`,
        },
        {
          code: "E.e.3",
          machine_name: "ee3_apply_email",
          widget: "text",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "ee3_apply_email",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  "ee2_apply_phone",
                  "ee3_apply_email",
                  "ee4_apply_website",
                ],
                allowNAs: false,
              },
            },
          ],
          label: "Email Address to Apply",
          maxLength: 100,
          tooltip: `Enter the email address by which prospective U.S. workers can contact the employer and apply for the job opportunity. The format must be name@emailaddress.top-level domain. If an email address is not available, please enter “N/A”.`,
        },
        {
          code: "E.e.4",
          machine_name: "ee4_apply_website",
          widget: "text",
          label: "Website Address (URL) to Apply",
          validate: [
            {
              url: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "ee4_apply_website",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  "ee2_apply_phone",
                  "ee3_apply_email",
                  "ee4_apply_website",
                ],
                allowNAs: false,
              },
            },
          ],
          maxLength: 70,
          tooltip: `Enter the website address by which prospective U.S. workers can contact the employer and apply for the job opportunity. The format must be domain name.domain suffix. Examples of valid suffixes include: .gov - Government agencies .edu - Educational institutions .org - Organizations (nonprofit) .mil - Military .com - commercial business .net - Network organizations If a website address is not available, please enter “N/A”.`,
        },
      ],
    },
  ],
};
